import { NgModule } from '@angular/core'
import { CommonModule, NgOptimizedImage } from '@angular/common'

import { FormsModule,
         ReactiveFormsModule } from '@angular/forms'

// import { CloudinaryModule } from '@cloudinary/ng'

import { RouterModule } from '@angular/router'

import { CoreMaterialModule } from './core-material.module'


// Modules
import { RecaptchaModule } from 'ng-recaptcha'
// import { LeafletModule } from './leaflet-module/index'
// import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'


// Guards
// import { AdminGuard } from './_guards/admin.guard'
// import { LoggedInGuard } from './_guards/logged-in.guard'
// import { LoggedOutGuard } from './_guards/logged-out.guard'

// Directives
import { AutofocusDirective } from './_directives/autofocus.directive'
import { AutosaveDirective } from './_directives/autosave.directive'
import { AutosizeDirective } from './_directives/autosize.directive'
import { DragScrollDirective } from './_directives/drag-scroll/drag-scroll.directive'
import { FadeDirective } from './_directives/fade.directive'
import { HoverableDirective } from './_directives/hoverable.directive'
import { LoadedDirective } from './_directives/loaded.directive'
import { OnSelectDirective } from './_directives/on-select.directive'
import { OnSelectOtherDirective } from './_directives/on-select-other.directive'
import { NearViewDirective } from './_directives/near-view.directive'
import { ShowIfDirective } from './_directives/show-if.directive'
import { StickyDirective } from './_directives/sticky.directive'
import { ScrollTriggerDirective } from './_directives/scroll-trigger.directive'
import { TooltipDirective } from './_directives/tooltip.directive'
import { ParallaxDirective } from './_directives/parallax.directive'

// Pipes
import { BytesPipe } from './_pipes/bytes.pipe'
import { EllipsisPipe } from './_pipes/ellipsis.pipe'
// import { InlineAddressPipe } from './_pipes/inline-address.pipe'
// import { OrdinalPipe } from './_pipes/ordinal.pipe'
import { RelativeDatePipe } from './_pipes/relative-date.pipe'
import { TruncatePipe } from './_pipes/truncate.pipe'
import { ToHtmlPipe } from './_pipes/to-html.pipe'
// import { AvatarComponent } from './avatar/avatar.component'
import { AdminBreadcrumbsComponent } from './admin-breadcrumbs/admin-breadcrumbs.component'
import { BannerComponent } from './banner/banner.component'
import { CountdownComponent } from './countdown/countdown.component'
import { CarouselComponent } from './carousel/carousel.component'
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component'
import { FadeContainerComponent } from './fade-container/fade-container.component'
import { FooterComponent } from './footer/footer.component'
import { FormSeparatorComponent } from './form-separator/form-separator.component'
import { HeaderComponent } from './header/header.component'
// import { AdminHeaderComponent } from './admin-header/admin-header.component'
import { LayoutDefaultComponent } from './layout-default/layout-default.component'
import { LayoutDefaultAdminComponent } from './layout-default-admin/layout-default-admin.component'
import { LoadingComponent } from './loading/loading.component'
import { MediaComponent } from './media/media.component'
// import { OrderFormComponent } from './order-form/order-form.component'
// import { RequestQuoteFormComponent } from './request-quote-form/request-quote-form.component'
// import { ServiceFormComponent } from './service-form/service-form.component'
// import { PolicyCurrentComponent } from './policy-current/policy-current.component'
// import { PolicyShowComponent } from './policy-show/policy-show.component'
import { PopupComponent } from './popup/popup/popup.component'
import { PopupConfirmComponent } from './popup/popup-confirm/popup-confirm.component'
// import { PopupMenuControlComponent } from './popup/popup-menu-control/popup-menu-control.component'
import { PathNotFoundComponent } from './path-not-found/path-not-found.component'
// import { QuillDisplayComponent } from './quill/quill-display/quill-display.component'
// import { QuillEditorComponent } from './quill/quill-editor/quill-editor.component'

import { RecaptchaInputComponent } from './recaptcha-input/recaptcha-input.component'
// import { SharedListenerComponent } from './shared-listener/shared-listener.component'
import { TooltipComponent } from './tooltip/tooltip.component'

// import { LoginFormComponent } from './login-form/login-form.component'
import { AppContainerComponent } from './app-container/app-container.component'
import { RoleGuard } from './_guards/role.guard'


@NgModule({
  imports: [
    CommonModule,
    NgOptimizedImage,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CoreMaterialModule,
    RecaptchaModule,
    // CloudinaryModule,
  ],
  declarations: [
    AutofocusDirective,
    AutosaveDirective,
    AutosizeDirective,
    DragScrollDirective,
    FadeDirective,
    HoverableDirective,
    LoadedDirective,
    OnSelectDirective,
    OnSelectOtherDirective,
    NearViewDirective,
    ShowIfDirective,
    StickyDirective,
    ScrollTriggerDirective,
    TooltipDirective,
    ParallaxDirective,

    BytesPipe,
    EllipsisPipe,
    RelativeDatePipe,
    TruncatePipe,
    ToHtmlPipe,
    AppContainerComponent,
    // AvatarComponent,
    AdminBreadcrumbsComponent,
    BannerComponent,
    BreadcrumbsComponent,
    CountdownComponent,
    CarouselComponent, 
    FadeContainerComponent,
    FooterComponent,
    FormSeparatorComponent,
    HeaderComponent,
    // AdminHeaderComponent,
    // LoginFormComponent,
    LayoutDefaultComponent,
    LayoutDefaultAdminComponent,
    LoadingComponent,
    MediaComponent,
    // OrderFormComponent,
    PathNotFoundComponent,
    RecaptchaInputComponent,
    // RequestQuoteFormComponent,
    // ServiceFormComponent,
    PopupComponent,
    PopupConfirmComponent,
    // PopupMenuControlComponent,
    TooltipComponent
  ],
  providers: [
    RoleGuard,
    BytesPipe,
    EllipsisPipe,
    RelativeDatePipe,
    TruncatePipe,
    ToHtmlPipe
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CoreMaterialModule,

    AutofocusDirective,
    AutosaveDirective,
    AutosizeDirective,
    DragScrollDirective,
    HoverableDirective,
    FadeDirective,
    LoadedDirective,
    OnSelectDirective,
    OnSelectOtherDirective,
    NearViewDirective,
    ShowIfDirective,
    StickyDirective,
    ScrollTriggerDirective,
    TooltipDirective,
    ParallaxDirective,

    BytesPipe,
    EllipsisPipe,
    RelativeDatePipe,
    TruncatePipe,
    AppContainerComponent,
    // AvatarComponent,

    AdminBreadcrumbsComponent,
    BannerComponent,
    BreadcrumbsComponent, 
    CountdownComponent,
    CarouselComponent,
    FadeContainerComponent,
    FooterComponent,
    FormSeparatorComponent,
    HeaderComponent,

    // LoginFormComponent,
    LayoutDefaultComponent,
    LayoutDefaultAdminComponent,
    LoadingComponent,
    MediaComponent,
    // OrderFormComponent,
    PathNotFoundComponent,
    RecaptchaInputComponent,
    // RequestQuoteFormComponent,
    // ServiceFormComponent,
    PopupComponent,
    PopupConfirmComponent,
    // PopupMenuControlComponent,
    TooltipComponent
  ],
})

export class SharedModule {}
